import { isPlainObject } from 'is-plain-object';
import qs from 'qs';

export const strapi_end_point = 'https://api.gurucool.xyz';
// export const BACKEND_URL = 'http://localhost/anas/group-server/';
export const BACKEND_URL = 'https://gurucool.xyz/group-server/';

export const isMobile = (() => {
  if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
    return false;
  }
  return /Mobile/.test(navigator.userAgent);
})();

// Recursively removes any object keys with a value of undefined
export function removeUndefineds<T>(obj: T): T {
  if (!isPlainObject(obj)) return obj;

  const target: { [name: string]: any } = {};

  for (const key in obj) {
    const val = obj[key];
    if (typeof val !== 'undefined') {
      target[key] = removeUndefineds(val);
    }
  }

  return target as T;
}

export async function getDeviceInfo() {
  const devices = await navigator.mediaDevices.enumerateDevices();

  return {
    audioInputDevices: devices.filter(device => device.kind === 'audioinput'),
    videoInputDevices: devices.filter(device => device.kind === 'videoinput'),
    audioOutputDevices: devices.filter(device => device.kind === 'audiooutput'),
    hasAudioInputDevices: devices.some(device => device.kind === 'audioinput'),
    hasVideoInputDevices: devices.some(device => device.kind === 'videoinput'),
  };
}

// This function will return 'true' when the specified permission has been denied by the user.
// If the API doesn't exist, or the query function returns an error, 'false' will be returned.
export async function isPermissionDenied(name: 'camera' | 'microphone') {
  const permissionName = name as PermissionName; // workaround for https://github.com/microsoft/TypeScript/issues/33923

  if (navigator.permissions) {
    try {
      const result = await navigator.permissions.query({ name: permissionName });
      return result.state === 'denied';
    } catch {
      return false;
    }
  } else {
    return false;
  }
}

type Cookie = {
  [key: string]: string;
};

export const getCookie = (name: string) => {
  let cookie: Cookie = {};
  document.cookie.split(';').forEach(function(el) {
    let [k, v] = el.split('=');
    cookie[k.trim()] = v;
  });
  return cookie[name];
};

export const getJwt = () => {
  const jwt = getCookie('token');
  return jwt || '';
};

export const getUser = () => {
  const user = getCookie('user');
  return user || '';
};

export const checkLogin = () => {
  const user = getUser();
  const jwt = getJwt();
  if (user && jwt) {
    return true;
  }
  return false;
};

export const getUserData = async (id: any) => {
  const query = qs.stringify(
    {
      filters: {
        user_id: id,
      },
      fields: ['id', 'first_name', 'last_name', 'about'],
      populate: {
        avatar: '*',
        user_id: {
          fields: ['id', 'username'],
        },
      },
    },
    {
      encodeValuesOnly: true, // prettify url
    }
  );
  const UserData = await fetch(`${strapi_end_point}/api/user-profiles?${query}`);
  const UserDecode = await UserData.json();
  return UserDecode.data[0];
};
